import React from "react";
import ReactApexChart from "react-apexcharts";
import { Box, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";

function TreeMap({ data }) {
	const theme = useTheme();

	// Map data for series structure required by ApexCharts
	const seriesData = data.map((item) => ({
		x: item.label,
		y: item.value,
	}));

	const options = {
		chart: {
			type: "treemap",
			//   height: 200,
			toolbar: { show: false },
		},
		plotOptions: {
			treemap: {
				enableShades: true,
				shadeIntensity: 0.4,
				reverseNegativeShade: true,
				colorScale: {
					ranges: [
						{ from: -6, to: -3, color: theme.palette.error.light },
						{
							from: -2.999,
							to: 0,
							color: theme.palette.error.light,
						},
						{
							from: 0.001,
							to: 3,
							color: theme.palette.success.light,
						},
						{
							from: 3.001,
							to: 6,
							color: theme.palette.success.light,
						},
					],
				},
			},
		},
		dataLabels: {
			enabled: true,
			style: {
				colors: [
					theme.palette.getContrastText(
						theme.palette.background.paper
					),
				],
			},
		},
		tooltip: {
			y: {
				formatter: (value) => `${value}%`,
			},
		},
	};

	const series = [
		{
			data: seriesData,
		},
	];

	return (
		<Box
			sx={{
				maxWidth: "92vw",
				marginTop: "1.5rem",
				marginLeft: "4vw",
				marginRight: "4vw",
				marginBottom: "5rem",
				height: "100%",
			}}
		>
			<ReactApexChart
				options={options}
				series={series}
				type="treemap"
				height={650}
			/>
		</Box>
	);
}

const data = [
	{ label: "AAPL", value: 0.53 },
	{ label: "SOFI", value: 0.78 },
	{ label: "META", value: 1.09 },
	{ label: "BABA", value: 1.12 },
	{ label: "TSLA", value: 2.16 },
	{ label: "CELH", value: 0.71 },
	{ label: "SNOW", value: 6 },
	{ label: "PLTR", value: 3.29 },
	{ label: "SE", value: -0.1 },
	{ label: "MELI", value: -0.43 },
	{ label: "COIN", value: -1.63 },
	{ label: "AMD", value: 1.86 },
	{ label: "NVDA", value: 1.03 },
	{ label: "ORCL", value: -0.4 },
	{ label: "CRM", value: 1.08 },
	{ label: "NFLX", value: 0.38 },
	{ label: "AMZN", value: 0.86 },
	{ label: "GOOGL", value: 1.44 },
	{ label: "PEP", value: -0.01 },
	{ label: "JNJ", value: -1.67 },
	{ label: "QCOM", value: 1.55 },
	{ label: "ABBV", value: -0.72 },
	{ label: "WMT", value: -0.4 },
	{ label: "MCD", value: -3.3 },
	{ label: "HD", value: -1.04 },
];

export default function Home() {
	return (
		<>
			<Typography
				component="h1"
				variant="h4"
				align="center"
				color="primary.dark"
				sx={{
					marginTop: "6rem",
				}}
			>
				Today's Market Movements
			</Typography>
			<TreeMap data={data}></TreeMap>
		</>
	);
}
